import React from "react";

const EyeTest = () => {
  return (
    <div>
      <h2>eye test</h2>
    </div>
  );
};

export default EyeTest;
